/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/anchor-is-valid */
/* eslint-disable no-shadow */
import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import { NavMenu } from '@jkhy/vsg-design-system';
import { UserState as UserState_ } from 'redux-oidc';
import { Base, BaseType as BaseType_ } from '../base-component';
import settingAPI from '../../../data/settings-api';
import BaseApi from '../../../data/base-api';
import { endLoading as endLoadingAction, startLoading as startLoadingAction } from '../../../redux/actions/loading-actions';

import { buildRequestOptions } from '../../../utils/helper';
import LINKS from '../../../utils/links';
import {
  isQDEnabledAction,
  qdExternalCommercialModelsCountFetched,
  qdExternalConsumerModelsCountFetched,
  renewalDocumentsCountFetched,
  QDEnabledModel as QDEnabledModel_,
  CountingModel as CountingModel_,
  getCurrentApplicationsCountAction
} from '../../../redux/actions/counts-qd-enabled-actions';
import { AppState as AppState_ } from '../../../redux/app-state';
import { FETCHING_ENDED, FETCHING_STARTED } from '../../../redux/actions/actionTypes/loading';
import { QDExternalModelByCustomerType } from '../../../data/models/Enum';
import DocAPI from '../../../data/doc-api';
import { AppDispatch } from '../../../data/models/AppDispatch';

type LeftSidebarContainerProps = {
  isQDEnabled: QDEnabledModel_,
  reqDocsFetched: CountingModel_,
  qdExternalCommercialModelsFetched: CountingModel_,
  qdExternalConsumerModelsFetched: CountingModel_,
  currentApplicationsFetched: CountingModel_,
  oidc: UserState_,
  onHandleCloseMenu: () => void,
  isQDEnabledAction: (params: QDEnabledModel_) => void,
  qdExternalCommercialModelsCountFetched: (params: CountingModel_) => void,
  qdExternalConsumerModelsCountFetched: (params: CountingModel_) => void,
  renewalDocumentsCountFetched: (params: CountingModel_) => void,
  setCurrentApplicationsCount: (params: CountingModel_) => void
  startLoading: () => Promise<typeof FETCHING_STARTED>,
  endLoading: () => Promise<typeof FETCHING_ENDED>,
} & BaseType_

export class LeftSidebarContainer extends Base<LeftSidebarContainerProps, {}> {
  constructor(props) {
    super(props);

    this.state = Object.create({
      reqDocCount: 0,
      inviteCount: 0,
    });
  }

  componentDidMount = async () => {
    const {
      isQDEnabled,
      reqDocsFetched,
      qdExternalCommercialModelsFetched,
      qdExternalConsumerModelsFetched,
      currentApplicationsFetched,
      isQDEnabledAction,
      qdExternalCommercialModelsCountFetched,
      qdExternalConsumerModelsCountFetched,
      renewalDocumentsCountFetched,
      setCurrentApplicationsCount,
      startLoading,
      endLoading,
    } = this.props;

    startLoading();

    try {
      if (!isQDEnabled.isFetched) {
        const response = await settingAPI.isQDEnabled();

        const { result, } = response;

        isQDEnabledAction({ isFetched: true, isEnabled: result, });

        if (result) {
          if (!qdExternalCommercialModelsFetched.isFetched) {
            // TODO: Extract this in the service layer
            const requestOptions = buildRequestOptions(
              `api/LoanApplications/GetEvaluatedQDModelsCount?customerType=${QDExternalModelByCustomerType.Commercial}`
            );

            const qdCommercialModelsCount = await BaseApi.performPlat($.ajax(requestOptions));

            if (qdCommercialModelsCount === 0) {
              this.props.history.push('/home');
            }

            qdExternalCommercialModelsCountFetched({ isFetched: true, count: qdCommercialModelsCount, });
          }

          if (!qdExternalConsumerModelsFetched.isFetched) {
            // TODO: Extract this in the service layer
            const requestOptions = buildRequestOptions(
              `api/LoanApplications/GetEvaluatedQDModelsCount?customerType=${QDExternalModelByCustomerType.Consumer}`
            );

            const qdConsumerModelsCount = await BaseApi.performPlat($.ajax(requestOptions));

            if (qdConsumerModelsCount === 0) {
              this.props.history.push('/home');
            }

            qdExternalConsumerModelsCountFetched({ isFetched: true, count: qdConsumerModelsCount, });
          }
        }
      }

      if (!reqDocsFetched.isFetched) {
        const { data: reqDocCount, } = await DocAPI.getAllRequestsCount();

        renewalDocumentsCountFetched({ isFetched: true, count: reqDocCount, });
      }

      if (!currentApplicationsFetched.isFetched) {
        // TODO: Extract this in the service layer
        const requestOptions = buildRequestOptions('api/LoanApplications/InquireCurrentRequestsCount');

        const { status, data, } = await BaseApi.performPlat(axios(requestOptions));

        if (status === 200) {
          setCurrentApplicationsCount({ isFetched: true, count: data, });
        }
      }
    } catch (err) {
      BaseApi.onError(err);
    } finally {
      endLoading();
    }
  };

  getLoanApplicationsLinks = (currentPathname) => {
    const {
      isQDEnabled,
      qdExternalCommercialModelsFetched,
      qdExternalConsumerModelsFetched,
      currentApplicationsFetched,
    } = this.props;

    const loanApplicationsLinks = [];

    if (isQDEnabled.isEnabled) {
      if (qdExternalCommercialModelsFetched.count > 0) {
        loanApplicationsLinks.push({
          title: 'NEW COMMERCIAL REQUEST',
          path: LINKS.NEW_COMMERCIAL_REQUEST,
          isActive: LINKS.NEW_COMMERCIAL_REQUEST === currentPathname,
          dataUI: 'NewRequestHistoryLink',
        });
      }

      if (qdExternalConsumerModelsFetched.count > 0) {
        loanApplicationsLinks.push({
          title: 'NEW CONSUMER REQUEST',
          path: LINKS.NEW_CONSUMER_REQUEST,
          isActive: LINKS.NEW_CONSUMER_REQUEST === currentPathname,
          dataUI: 'NewConsumerRequestLink',
        });
      }

      loanApplicationsLinks.push({
        title: 'HISTORY',
        path: LINKS.LOAN_APPLICATION_HISTORY,
        isActive: LINKS.LOAN_APPLICATION_HISTORY === currentPathname,
        dataUI: 'ApplicationHistoryLink',
      });
    }

    if (currentApplicationsFetched.count > 0) {
      loanApplicationsLinks.push({
        title: 'Current Requests',
        path: LINKS.CURRENT_REQUESTS,
        number: currentApplicationsFetched.count,
        isActive: LINKS.CURRENT_REQUESTS === currentPathname,
        dataUI: 'CurrentRequestsLink',
      });
    }

    return loanApplicationsLinks;
  }

  content = () => {
    const {
      reqDocsFetched,
    } = this.props;

    const currentPathname = this.props.location.pathname;

    const sections = [
      {
        links: [
          {
            title: 'HOME',
            path: LINKS.HOME,
            isActive: LINKS.HOME === currentPathname,
            dataUI: 'HomeLink',
          }
        ],
      },
      {
        title: 'Requested Documents',
        links: [
          {
            title: 'REQUESTED',
            path: LINKS.REQUIRED,
            number: reqDocsFetched.count,
            isActive: LINKS.REQUIRED === currentPathname,
            dataUI: 'RequestLink',
          },
          {
            title: 'HISTORY',
            path: LINKS.HISTORY,
            isActive: LINKS.HISTORY === currentPathname,
            dataUI: 'RequestHistoryLink',
          }
        ],
      }
    ];

    // Loan Applications Links
    const loanApplicationsLinks = this.getLoanApplicationsLinks(currentPathname);

    const isQDEnabledFlag = this.props.isQDEnabled.isEnabled;
    const currentApplicationsFetchedCount = this.props.currentApplicationsFetched.count;

    if (isQDEnabledFlag || (!isQDEnabledFlag && currentApplicationsFetchedCount > 0)) {
      sections.push({
        title: 'Loan Applications',
        links: loanApplicationsLinks,
      });
    }

    return (
      <NavMenu
        onLinkClick={this.props.onHandleCloseMenu}
        sections={sections}
        dataUI="NavMenu"
      />
    );
  }
}

export default withRouter<any, any>(connect(
  (state: AppState_) => ({
    isQDEnabled: state.isQDEnabled,
    reqDocsFetched: state.reqDocsFetched,
    qdExternalCommercialModelsFetched: state.qdExternalCommercialModelsFetched,
    qdExternalConsumerModelsFetched: state.qdExternalConsumerModelsFetched,
    currentApplicationsFetched: state.currentApplicationsFetched,
    oidc: state.oidc,
  }),
  (dispatch: AppDispatch) => {
    return {
      isQDEnabledAction: (params: QDEnabledModel_) => dispatch(isQDEnabledAction(params)),
      qdExternalCommercialModelsCountFetched: (params: CountingModel_) => dispatch(qdExternalCommercialModelsCountFetched(params)),
      qdExternalConsumerModelsCountFetched: (params: CountingModel_) => dispatch(qdExternalConsumerModelsCountFetched(params)),
      setCurrentApplicationsCount: (params: CountingModel_) => dispatch(getCurrentApplicationsCountAction(params)),
      renewalDocumentsCountFetched: (params: CountingModel_) => dispatch(renewalDocumentsCountFetched(params)),
      startLoading: () => dispatch(startLoadingAction()),
      endLoading: () => dispatch(endLoadingAction()),
    };
  }
)(LeftSidebarContainer));
